import React, { useState, useContext } from "react";
// import WithAuthentication from "Authentication/AuthenticationContext.ts";
// import { useParams } from "react-router-dom";
// import Swal from "sweetalert2";
// import { connection } from "utils/apiConnection.ts";

const BusinessContext = React.createContext({
  product: {
    id: "",
    title: "",
    description: "",
    rate: "",
    sharePoint: "",
    shareLink: "",
    medias: "",
    similarProducts: [{ value: "" }],
    tags: [],
    comments: [],
    coverImg: "",
    shareLinkStatus: "",
    sharePointStatus: "",
  },
  comments: [
    {
      id: "",
      title: "",
      description: "",
      mtm: "",
      rate: "",
      uid: "",
      fullname: "",
    },
  ],
  contact: {
    name: "",
    tell: "",
    mobile: "",
    socialMedia: "",
  },
  bpid: "",
  products: [
    {
      id: "",
      title: "",
      description: "",
      rate: "",
      coverImg: "",
      sharePoint: "",
      shareLink: "",
      medias: "",
      similarProducts: [{ value: "" }],
      tags: [],
      comments: [],
      shareLinkStatus: "",
      sharePointStatus: "",
    },
  ],
  space: "",
  shareLink: "",
  logbeforejoin: "",
  business: "",
  setProduct: (state) => {},
  setComments: (state) => {},
  setContact: (state) => {},
  setbpid: (state) => {},
  setProducts: (state) => {},
  setSpace: (state) => {},
  setShareLink: (state) => {},
  setLogbeforejoin: (state) => {},
  setBusiness: (state) => {},
});
export default BusinessContext;

export const BusinessContextProvider = ({ children }) => {
  // let params = useParams();
  // const auth = useContext(WithAuthentication);
  const [product, setProduct] = useState({
    id: "",
    title: "",
    description: "",
    rate: "",
    covrImg: "",
    sharePoint: "",
    shareLink: "",
    medias: "",
    similarProducts: [{ value: "" }],
    tags: [],
    comments: [],
    coverImg: "",
  });
  const [comments, setComments] = useState([
    {
      id: "",
      title: "",
      description: "",
      mtm: "",
      rate: "",
      uid: "",
      fullname: "",
    },
  ]);
  const [contact, setContact] = useState({
    name: "",
    tell: "",
    mobile: "",
    socialMedia: "",
  });
  const [bpid, setbpid] = useState();
  const [products, setProducts] = useState([]);
  const [space, setSpace] = useState();
  const [shareLink, setShareLink] = useState();
  const [logbeforejoin, setLogbeforejoin] = useState();
  // const [businessC, setBusinessC] = useState();
  // async function apihandler() {
  //   let keyvalues = {
  //     uid: auth.userInfo.id,
  //     bpid: businessC.id,
  //   };
  //   const result = await connection("joinclub", keyvalues);
  //   return result.status;
  // }
  // function theAlert() {
  //   console.log(auth);
  //   Swal.fire({
  //     title: "عضویت در باشگاه مشتریان",
  //     text: `آیا میخواهید در فروشگاه ${businessC.title} عضو شوید؟`,
  //     icon: "question",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "بله",
  //     cancelButtonText: "خیر",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       let status = await apihandler();
  //       if (status == 1) {
  //         Swal.fire("موفق", "با موفقیت عضو باشگاه مشتریان شدید.", "success");
  //         auth.joinclub({ id: businessC.id, shopSuffix: params.shop_suffix });
  //       } else if (status == 0) {
  //         Swal.fire(
  //           "ناموفق",
  //           "مشکلی در عضویت در باشگاه مشتریان به وجود آمده است",
  //           "error"
  //         );
  //       } else if (status == -1) {
  //         Swal.fire(
  //           "خطا!",
  //           "شما عضو باشگاه مشتریان این فروشگاه هستید",
  //           "warning"
  //         );
  //       }
  //     }
  //   });
  // }
  return (
    <BusinessContext.Provider
      value={{
        product,
        comments,
        contact,
        bpid,
        products,
        space,
        shareLink,
        logbeforejoin,
        // businessC,
        setProduct,
        setComments,
        setContact,
        setbpid,
        setProducts,
        setSpace,
        setShareLink,
        setLogbeforejoin,
        // setBusinessC,
        // theAlert,
      }}
    >
      {children}
    </BusinessContext.Provider>
  );
};
